<template>
  <div class="sidebar-footer">
    <Transition>
      <ul
        v-if="isSidebarOpen"
        class="sidebar-footer--links t-flex t-flex-1 t-flex-justify-content-center"
      >
        <li class="t-flex-auto">
          {{ version }}
        </li>
        <!-- <li>
          <AppButtonLink @on-click="onClickOpenClose">
            <p>Licences</p>
          </AppButtonLink>
        </li> -->
        <li>
          <AppButtonLink :href="dataPrivacyStatement" :target="'_blank'">
            <p>{{ t("footer.privacyShort") }}</p>
          </AppButtonLink>
        </li>
      </ul>
    </Transition>
  </div>
  <!-- <Teleport to="body">
    <CookieConsent
      class="cookie-consent"
      :is-open="isConsentOpen"
      :is-optional="isOptional"
      :domain="domainName"
      :disabledCategories="[]"
      @exit="onClickOpenClose"
      @open="onClickOpenClose"
    />
  </Teleport> -->
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, ref } from "vue"
import { useLinks } from "@/composables/useLinks"
import { useI18n } from "vue-i18n"
import { version } from "../../../package.json"

export default defineComponent({
  components: {
    AppButtonLink: defineAsyncComponent(
      () => import("@/components/AppButtonLink/AppButtonLink.vue")
    ),
    CookieConsent: defineAsyncComponent(
      () => import("@/components/global/CookieConsent/CookieConsent.vue")
    )
  },
  props: {
    isSidebarOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    version() {
      return version
    }
  },
  setup() {
    const { t } = useI18n()
    const { dataPrivacyStatement } = useLinks()

    const currentYear = new Date().getFullYear()
    const isConsentOpen = ref(false)
    const isOptional = sessionStorage.getItem("isOptional") != null
    const domainName = window.location.hostname

    function onClickOpenClose() {
      isConsentOpen.value = !isConsentOpen.value
    }

    return {
      t,
      dataPrivacyStatement,
      currentYear,
      isOptional,
      domainName,
      isConsentOpen,
      onClickOpenClose,
      version // Add this line
    }
  }
})
</script>

<style lang="scss" scoped>
@use "@/styles/mixins/typography.scss" as *;
@use "@/styles/variables/spacing.scss" as *;

$fixed-footer-height: 52px;

.sidebar-footer {
  @include tg-small;

  color: var(--telekom-color-text-and-icon-additional);
  padding: $space-2 0 $space-2 $space-4;
  // height: $fixed-footer-height;
  gap: $space-1;
  overflow: hidden;

  &--links {
    gap: $space-4;
  }

  li p {
    @include tg-small;

    color: var(--telekom-color-text-and-icon-additional);

    &:hover {
      color: var(--telekom-color-primary-hovered);
    }

    &:active {
      color: var(--telekom-color-primary-pressed);
    }
  }
}

.v-enter-active {
  transition: opacity 0.8s ease;
}
.v-leave-active {
  transition: opacity 0.1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
